import CONFIG from '../config';
import {instance} from './index';

export async function getUserInfo() {
  const response = await instance().get(`${CONFIG.USER_NAME}`);
  return response.data;
}
